angular.module('rjmNg.directives').directive "magentoPreferences", [
  () ->
    restrict: "E"
    templateUrl: "directive.magentoPreferences.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      showSkip: '&'
      gotoNext: '&'
    require: "^?rjmUi"
    controller: [
      "$clientAppUrl"
      "$anchorScroll"
      "$location"
      "$q"
      "$rootScope"
      "$routeParams"
      "app"
      "appRoute"
      "currencyService"
      "Clients"
      "notification"
      "timezoneService"
      (
        $clientAppUrl
        $anchorScroll
        $location
        $q
        $rootScope
        $routeParams
        app
        appRoute
        currencyService
        Clients
        notification
        timezoneService
      ) ->

        view = @

        _navigateToNextStep = () ->
          if(view.isChannels)
            view.gotoNext()
          else
            $location.path($clientAppUrl('/magento/connect/mysql'))

        init = ->
          ## View URLs
          view.inviteMembersUrl = $clientAppUrl "/magento/invite"

          view.loading = true
          view.client = null
          view.clientId = $routeParams.clientId
          view.isChannels = app.isMagentoChannels()

          $anchorScroll()

          view.options =
            has_guest_checkout: [
              value: "0"
              text: "No"
            ,
              value: "1"
              text: "Yes"
            ]
            week_start_day: [
              value: "1"
              text: "Monday"
            ,
              value: "7"
              text: "Sunday"
            ],
            magento_version: [
              value: "1"
              text: "Magento 1"
            ,
              value: "2"
              text: "Magento 2"
            ]

          $q.all([timezoneService.fetch(), currencyService.fetch(), Clients.get(view.clientId)])
          .then ([timezones, currencies, clientInfo]) ->
            view.options.timezones = timezones.data
            view.options.currencies = currencies.data
            view.client = clientInfo
            {
              has_guest_checkout,
              timezone,
              default_currency,
              week_start_day,
              magento_version
            } = view.client.properties
            angular.extend view.client.properties,
              has_guest_checkout: has_guest_checkout or "0"
              timezone: timezone or "America/New_York"
              default_currency: default_currency or "USD"
              week_start_day: week_start_day or "1"
              magento_version: magento_version or "1"
            view.loading = false

        view.savePreferences = ->
          view.loading = true

          Clients.save(view.client)
            .then (response) ->
              view.loading = false
              _navigateToNextStep()
            .catch (error) -> 
              view.loading = false
              notification.error("We've encountered an error saving your settings.", "Please verify that all settings are entered correctly.", "magento-preferences", { dismissable: false, bindHtml: true })

        view.$onInit = () ->
          init()

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "magentoPreferences", scope.view.loading

      
]
